import AccountDetailsDisplay from './account-details-display';

export default AccountDetailsDisplay;
